export default function idFromLink(href:string|null):string {
  const idPart = (href || '').split('/').pop()!;
  return decodeURIComponent(idPart);
}
